/**
 * BoardTaskPriority Utilities
 *
 * Helper functions for working with BoardTaskPriority enum values
 */

import { BoardTaskPriority } from '@/types/enums/BoardTaskPriority';

/**
 * Get the sort order for a priority value
 * Lower numbers = higher priority (urgent > high > medium > low)
 */
export function getPrioritySortOrder(priority?: string): number {
  switch (priority) {
    case BoardTaskPriority.URGENT:
      return 0;
    case BoardTaskPriority.HIGH:
      return 1;
    case BoardTaskPriority.MEDIUM:
      return 2;
    case BoardTaskPriority.LOW:
      return 3;
    default:
      return 4; // Unknown priorities sort last
  }
}
